module.exports = __webpack_public_path__ + "static/media/exclamation-circle.b94b8db1.svg";